import { render, staticRenderFns } from "./unionGoodsCorrect.vue?vue&type=template&id=9122918c&"
import script from "./unionGoodsCorrect.vue?vue&type=script&lang=js&"
export * from "./unionGoodsCorrect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "unionGoodsCorrect.vue"
export default component.exports